import React, { Component } from "react";
import { object } from "prop-types";
import BloxButton from "sub_components/Common/BloxButton";
import ScrollView from "sub_components/Common/BloxScrollViewNew";
import { ILA_HUTS } from "utils/CommonConstants";
const CDN_URL = process.env.REACT_APP_CDN_URL;

const AtlantaDefault = `${CDN_URL}support/ticketing/location-atlanta-icon-default-lg.svg`;
const AtlantaSelected = `${CDN_URL}support/ticketing/location-atlanta-selected-lg.svg`;
const BirminghamDefault = `${CDN_URL}support/ticketing/location-birmingham-building-default-lg.svg`;
const BirminghamSelected = `${CDN_URL}support/ticketing/location-birmingham-selected-lg.svg`;
const ChattanoogaDefault = `${CDN_URL}common/chattanooga-building-lg.svg`;
const ChattanoogaSelected = `${CDN_URL}support/ticketing/location-chattanooga-selected-lg.svg`;
const HuntsvilleDefault = `${CDN_URL}support/ticketing/location-huntsville-building-default-lg.svg`;
const HuntsvilleSelected = `${CDN_URL}support/ticketing/location-huntsville-selected-lg.svg`;

class LocationSelection extends Component {
  constructor(props) {
    super(props);

    this.state = {
      locations: [],
      called: false,
    };
  }
  onMouseEnter = (id) => {
    const icon = document.getElementById(id);

    if (id === "atlanta") {
      icon.src = AtlantaSelected;
    } else if (id === "BHR") {
      icon.src = BirminghamSelected;
    } else if (id === "CHA") {
      icon.src = ChattanoogaSelected;
    } else {
      icon.src = HuntsvilleSelected;
    }
  };
  onMouseLeave = (id, typeIcon) => {
    const icon = document.getElementById(id);
    icon.src = typeIcon;
  };
  componentDidMount() {
    const { data, onSelect } = this.props;
    const { product } = data;
    const selected = data.location;
    if (product === "Portal" && !selected) {
      onSelect("location", { data: "portal selected" }, true);
    }
  }

  hasService = (locationTag) => {
    const { data, services } = this.props;

    if (!services) {
      return false;
    }

    let filteredCompanyServices = [];
    let product = data.product;
    if (services) {
      if (product === "Colocation") {
        product = "colo";
      } else if (product === "Network Services") {
        product = "network";
      } else if (product === "Storage") {
        product = "storage";
      }
      filteredCompanyServices = services.filter(
        (coService) =>
          coService.name === product &&
          coService.active === true &&
          coService?.datacenterName.toLowerCase() === locationTag.toLowerCase()
      );
    }

    if (
      filteredCompanyServices.length === 0 &&
      services !== null &&
      services.length !== 0
    ) {
      return false;
    } else {
      return true;
    }
  };

  getLocationCount = () => {
    //const datacenters = ['atl', 'bhm', 'hsv', 'gsp', 'cha', 'myr'];
    const datacenters = ["bhm", "hsv", "gsp", "cha", "myr"];
    const locations = [];

    datacenters.forEach((s) => {
      if (this.hasService(s)) {
        locations.push(s);
      }
    });
    return locations;
  };
  moveToNextScreen = (locations) => {
    const { onSelect, data } = this.props;
    const selected = data.location;
    if (!selected) {
      onSelect("location", { data: locations[0] }, true);
    }

    this.setState({ called: true });
  };
  updateEditParams = (location) => {
    const { updateData, closeEditModal } = this.props;
    updateData("location", null, location);

    closeEditModal();
  };

  getLocationIcon = (tag) => {
    const { data } = this.props;
    const selected = data.location;

    const atlantaIcon =
      selected === "atlanta" ? AtlantaSelected : AtlantaDefault;
    const birminghamIcon =
      selected === "birmingham" ? BirminghamSelected : BirminghamDefault;
    const chattanoogaIcon =
      selected === "chattanooga" ? ChattanoogaSelected : ChattanoogaDefault;
    const huntsvilleIcon =
      selected === "huntsville" ? HuntsvilleSelected : HuntsvilleDefault;
    switch (tag) {
      case "ATL":
        return atlantaIcon;
      case "BHM":
        return birminghamIcon;
      case "CHA":
        return chattanoogaIcon;
      case "HSV":
        return huntsvilleIcon;

      default:
        return birminghamIcon;
    }
  };

  returnLocation = (displayName, tag) => {
    const { onSelect, phase } = this.props;
    const lowerName = displayName.toLowerCase();
    const locationIcon = this.getLocationIcon(tag);
    return (
      <div
        className="location-selection"
        onClick={
          phase !== "edit"
            ? () => onSelect("location", { data: lowerName }, true)
            : () => this.updateEditParams(lowerName)
        }
        onMouseEnter={() => this.onMouseEnter(lowerName)}
        onMouseLeave={() => this.onMouseLeave(lowerName, locationIcon)}
        data-cy={tag}
      >
        <img src={locationIcon} id={lowerName} />
        <div className="title heading76">{displayName}</div>
      </div>
    );
  };

  render() {
    const { closeModal, phase, data } = this.props;
    const { called } = this.state;
    const ila = data?.type === "ila" ? true : false;

    const locations = this.getLocationCount();

    if (locations.length === 1 && !called) {
      this.moveToNextScreen(locations);
    }

    return (
      <div className="location-selection-stage">
        <ScrollView>
          <div className={"location-selection-wrapper wrap"}>
            {/* {this.hasService('atl') && this.returnLocation('Atlanta', 'ATL')} */}
            {!ila &&
              this.hasService("bhm") &&
              this.returnLocation("Birmingham", "BHM")}
            {!ila &&
              this.hasService("cha") &&
              this.returnLocation("Chattanooga", "CHA")}
            {!ila &&
              this.hasService("gsp") &&
              this.returnLocation("Greenville", "GSP")}
            {!ila &&
              this.hasService("hsv") &&
              this.returnLocation("Huntsville", "HSV")}
            {!ila &&
              this.hasService("myr") &&
              this.returnLocation("Myrtle", "MYR")}
            {ila &&
              ILA_HUTS.map((hut) => this.returnLocation(hut.name, hut.id))}
          </div>
        </ScrollView>
        {phase !== "edit" && (
          <div className={"cancel-button"}>
            <BloxButton
              title="CANCEL"
              enabled={true}
              customClass="blox-button-swipe"
              onClick={closeModal}
              id="cancel-button-swipe"
            />
          </div>
        )}
      </div>
    );
  }
}

LocationSelection.propTypes = {
  data: object,
};

LocationSelection.defaultProps = {
  data: { location: { singleLocation: null, location: "" } },
};

export default LocationSelection;
